export default __webpack_public_path__ + "static/artifakt-element-light-0f9e7ee87d5485201bd1b91c0a8cc0c1.woff";